import { isDefined } from 'fitify-utils/src/properties'
import {
  type Id,
  toast,
  type ToastContent,
  type ToastItem,
  type ToastOptions,
} from 'react-toastify'

const messageIds = new Set<Id>()

toast.onChange((payload: ToastItem) => {
  switch (payload.status) {
    case 'added':
      messageIds.add(payload.id)
      break
    case 'removed':
      messageIds.delete(payload.id)
      break
    default:
      break
  }
})

export const showToast = (
  content: ToastContent,
  options?: ToastOptions
): Id => {
  const shouldUpdate =
    isDefined(options?.toastId) && messageIds.has(options.toastId)
  if (shouldUpdate) {
    toast.update(options.toastId!, { render: content, ...(options || {}) })
    return options.toastId!
  } else {
    return toast(content, options)
  }
}

export const TOAST_AUTO_CLOSE = 5000
